import styles from "../styles/Footer.module.css";
import { Link } from "react-router-dom";
import { EULA_URL } from "../utils/legal";

const Footer = () => {
  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <div className={styles.legalLinks}>
          <Link to="/about">About Us</Link>
          <span className={styles.separator}>•</span>
          <Link to="/terms">Terms of Service &amp; Privacy Policy</Link>
          <span className={styles.separator}>•</span>
          <Link to="/privacy">Privacy Policy</Link>
          <span className={styles.separator}>•</span>
          <a href={EULA_URL} target="_blank" rel="noopener noreferrer">
            I AGREE to the End User License Agreement (EULA)
          </a>
          <span className={styles.separator}>•</span>
          <a href="mailto:Rigrestrapp@gmail.com">Contact Us</a>
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.card}>
          <h2 className={styles.motto}>
            {/* copyright@RIG REST'R @2026 */}
            Copyright © 2023 - 2026 RIG REST'R®. All rights reserved.
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Footer;
